import { ButtonGroup } from '@vds/buttons';
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@vds/modals';
import { Body } from '@vds/typography';
import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { isDesktop, isTab } from '../utils/globalConfig';
import {  useDispatch, useSelector } from 'react-redux';
import { setConfirmationPage, setUnauthToAuth } from '../../features/selectedData/selectedDataReducer';
import Cookies from 'js-cookie';
import { dispatchDeviceAndPlansImpression } from '../../shared/utils/tagging'
import { saveDeviceDetails} from '../../features/selectedData/persistantDataReducer';
const Space = styled.div`
padding-top: 24px;
`

const StyledCenteredModal = styled(Modal)`
.modal-content {
    text-align: center;
}
.modal-header {
    text-align: center;
}
.modal-body {
    text-align: center;
}
`
const StyledPadding = styled.div`
padding-left: 24px;
`

const NoplanModal = ({ showNoPlanChangeModal, noPlanChangeModalData, setShowNoPlanChangeModal, deviceSelectionData }) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { confirmedPlanData } = useSelector(state => state?.persistantReducer);
    const { failedUpdateCartData } = useSelector(state => state?.selectedReducer);

    const handleModalCTA1 = () => {
        setShowNoPlanChangeModal(false);

        Cookies.remove('NsaUnAuthSessionId');
        dispatch(setUnauthToAuth(false));
        
        dispatch(saveDeviceDetails(deviceSelectionData?.deviceDetails));
        dispatchDeviceAndPlansImpression(deviceSelectionData?.deviceDetails,confirmedPlanData,failedUpdateCartData)
        dispatch(setConfirmationPage(true));
      
        navigate(noPlanChangeModalData?.modalCTA2Url || '/itpconfirmation', { replace: true });
    };

    const handleModalCTA2 = () => {
        setShowNoPlanChangeModal(false);
    };
    const handleModalClose = () => {
        setShowNoPlanChangeModal(false);
    };
    return (
        <Modal
        opened={!!showNoPlanChangeModal}
        onOpenedChange={(opened) => !opened && handleModalClose()}
        ariaLabel="noPlanChangeModal"
        id="noPlanChangeModal"
        centered
    >
        <ModalTitle bold size="medium" primitive='h1'>{noPlanChangeModalData?.heading}</ModalTitle>
        <Space/>
            <Body size="large">{noPlanChangeModalData?.subHeading}</Body>
          <Space/>     
                                        
            <ButtonGroup
            childWidth={'100%'}
            viewport={'desktop'}
            rowQuantity={{ desktop: 2 }}
            data={[
                {
                children: noPlanChangeModalData?.modalCTA1,
                size: 'large',
                use: 'textLink',
                width: 'auto',
                onClick: () => handleModalCTA1(),
                },
                {
                children:noPlanChangeModalData?.modalCTA2,
                size: 'large',
                use: 'primary',
                width: 'auto',
                onClick:() => handleModalCTA2(),
                },
            ]}
            alignment={'center'}
            />
        
    </Modal>
    );
}

export default NoplanModal;